import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; // Adjust based on your router
import { useTranslation } from "react-i18next"; // If using react-i18next
import Icon from "../AppIcon"; // Your Icon component
import Input from "./Input";
import LanguageSwitcher from "../../LanguageSwitcher";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSearchActive, setIsSearchActive] = useState(false);
  // States (assuming these are defined; add if missing)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isUser, setIsUser] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false); // If still needed
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Replace with actual auth logic
  const [cartCount, setCartCount] = useState(0); // Replace with actual cart logic
  const [isShaking, setIsShaking] = useState(false);
  const [isEmptyPulse, setIsEmptyPulse] = useState(false);
  const [products, setProducts] = useState([]); // For search results
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Refs
  const searchRef = useRef(null);
  const userMenuRef = useRef(null);
  const menuRef = useRef(null); // Added for mobile menu click-outside

  // Assuming these functions are defined elsewhere; add implementations if needed
  const isActivePath = (path) => window.location.pathname === path;
  const handleSearch = (e) => {
    e.preventDefault();
    // Your search logic here
    console.log("Searching for:", searchQuery);
  };
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    // Trigger search API if needed
  };
  const handleLogout = () => {
    // Your logout logic
    console.log("Logged out");
  };
  const isRTL = false; // Replace with actual RTL detection

  // Click-outside for mobile menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };
    if (isMobileMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  // Click-outside for user menu (if needed)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUser(false);
      }
    };
    if (isUser) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isUser]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-border z-50 ${
          isRTL ? "font-cairo" : "font-sans"
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Left Section: Logo */}
            <Link
              to="/"
              className="flex items-center space-x-2 hover:opacity-80 transition-smooth"
            >
              <img
                src="/assets/images/logo.png"
                alt="logo"
                className="w-20 h-20 object-cover rounded-[16px]"
              />
            </Link>

            {/* Center Section: Navigation (Home, Categories, About Us) */}
            <nav className="hidden lg:flex items-center space-x-8">
              <div className="flex flex-col lg:flex-row gap-4 lg:gap-12 justify-center items-center p-4 lg:p-0">
                <button
                  onClick={() => navigate("/")}
                  role="menuitem"
                  className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                >
                  {t("home")}
                </button>
                <button
                  onClick={() => navigate("/product-listing")}
                  role="menuitem"
                  className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                >
                  {t("categories")}
                </button>
                <button
                  onClick={() => navigate("/about-us")}
                  role="menuitem"
                  className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                >
                  {t("navigation.aboutUs")}
                </button>
              </div>
            </nav>

            {/* Right Section: Search, User Menu, Cart */}
            <div className="hidden lg:flex items-center space-x-4">
              {/* Search */}
              <div className="relative" ref={searchRef}>
                <form onSubmit={handleSearch} className="relative">
                  <Input
                    type="search"
                    placeholder={t("search.placeholder")}
                    value={searchQuery}
                    onChange={handleInputChange}
                    className="w-64 pl-10 rounded-[24px]"
                  />
                  <Icon
                    name="Search"
                    size={18}
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary"
                  />

                  {/* قائمة النتائج - حطها هنا داخل الـ form عشان تكون dropdown من السيرش */}
                  {isLoading && (
                    <p className="mt-2 text-sm text-gray-500">جاري البحث...</p>
                  )}
                  {error && (
                    <p className="mt-2 text-sm text-red-500">{error}</p>
                  )}
                  {products && products.length > 0 ? (
                    <ul className="absolute top-full mt-2 w-64 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                      {products.map((product, index) => (
                        <li
                          key={product.id || index}
                          className="p-2 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                          onClick={() => {
                            window.location.href = `/product-detail?id=${product.id}`;
                            // navigate(`/product/${product.id}`);
                          }}
                        >
                          {product.name || product.title || "منتج غير معروف"}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    searchQuery &&
                    !isLoading && (
                      <p className="mt-2 text-sm text-gray-500">
                        لا يوجد منتجات مطابقة
                      </p>
                    )
                  )}
                </form>
              </div>

              {/* User Menu */}
              <div className="relative" ref={userMenuRef}>
                <button
                  onClick={() => setIsUser(!isUser)}
                  className="flex items-center space-x-2 p-2 text-text-secondary hover:text-primary transition-smooth"
                >
                  <Icon
                    name={isAuthenticated ? "UserCheck" : "User"}
                    size={20}
                  />
                  <Icon
                    name="ChevronDown"
                    size={14}
                    className="hidden sm:block"
                  />
                </button>

                {isUser && (
                  <div className="absolute top-full right-0 mt-2 w-48 bg-white border border-border rounded-[16px] shadow-lg z-50">
                    <div className="p-2">
                      {isAuthenticated ? (
                        <>
                          <Link
                            to="/edit-profile"
                            className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                          >
                            <Icon name="User" size={16} />
                            <span>{t("userMenu.myAccount")}</span>
                          </Link>
                          <Link
                            to="/order-history"
                            className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                          >
                            <Icon name="Package" size={16} />
                            <span>{t("userMenu.myOrders")}</span>
                          </Link>
                          <Link
                            to="/wishlist"
                            className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                          >
                            <Icon name="Heart" size={16} />
                            <span>{t("userMenu.wishlist")}</span>
                          </Link>
                          <hr className="my-2 border-border" />
                          <button
                            onClick={handleLogout}
                            className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                          >
                            <Icon name="LogOut" size={16} />
                            <span>{t("userMenu.signOut")}</span>
                          </button>
                        </>
                      ) : (
                        <>
                          <Link
                            to="/login"
                            className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                          >
                            <Icon name="LogIn" size={16} />
                            <span>{t("userMenu.signIn")}</span>
                          </Link>
                          <Link
                            to="/register"
                            className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                          >
                            <Icon name="UserPlus" size={16} />
                            <span>{t("userMenu.createAccount")}</span>
                          </Link>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Cart */}
              <Link
                to="/shopping-cart"
                className="relative p-2 text-text-secondary hover:text-primary transition-smooth"
                aria-label="Shopping Cart"
              >
                <Icon
                  name="ShoppingCart"
                  size={20}
                  className={`${isShaking ? "animate-shake" : ""} ${
                    isEmptyPulse ? "animate-pulse-glow" : ""
                  }`}
                />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-accent text-white text-xs font-medium rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                )}
              </Link>
            </div>

            {/* Mobile Menu Toggle - visible only on small screens */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-text-secondary hover:text-primary transition-smooth"
              aria-label="Toggle menu"
            >
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={20} />
            </button>
          </div>
        </div>

        {/* Mobile Search Overlay - Removed or integrated if not needed, as search is now in menu */}

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div
            ref={menuRef} // Now defined
            className="lg:hidden border-t border-border bg-white shadow-lg animate-slide-down text-right"
            role="menu"
          >
            <nav className="p-6 space-y-4 max-h-screen overflow-y-auto text-right">
              {/* Navigation Links */}
              <button
                onClick={() => {
                  navigate("/");
                  setIsMobileMenuOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition-colors text-right ${
                  isActivePath("/")
                    ? "bg-primary/10 text-primary"
                    : "text-text-primary hover:bg-muted"
                }`}
                role="menuitem"
              >
                {t("home")}
              </button>
              <button
                onClick={() => {
                  navigate("/product-listing");
                  setIsMobileMenuOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition-colors text-right ${
                  isActivePath("/product-listing")
                    ? "bg-primary/10 text-primary"
                    : "text-text-primary hover:bg-muted"
                }`}
                role="menuitem"
              >
                {t("categories")}
              </button>
              <button
                onClick={() => {
                  navigate("/about-us");
                  setIsMobileMenuOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition-colors text-right ${
                  isActivePath("/about-us")
                    ? "bg-primary/10 text-primary"
                    : "text-text-primary hover:bg-muted"
                }`}
                role="menuitem"
              >
                {t("navigation.aboutUs")}
              </button>
              <button
                onClick={() => {
                  navigate("/contact-us");
                  setIsMobileMenuOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition-colors text-right ${
                  isActivePath("/contact-us")
                    ? "bg-primary/10 text-primary"
                    : "text-text-primary hover:bg-muted"
                }`}
                role="menuitem"
              >
                {t("navigation.contactUs")}
              </button>

              {/* Search Input - Stays open, no auto-close on interaction */}
              <form onSubmit={handleSearch} className="relative mt-6">
                <Input
                  type="search"
                  placeholder={t("search.placeholder")}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)} // Keeps setting query, but results show only on focus
                  onFocus={() => setIsSearchActive(true)} // Add this to show results only when focused
                  onBlur={() => setTimeout(() => setIsSearchActive(false), 200)} // Hide after a short delay on blur (to allow clicks on results)
                  className="w-full pl-12 pr-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary"
                  // Removed autoFocus to prevent auto-triggering
                  aria-label="Search"
                />
                <Icon
                  name="Search"
                  size={20}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 text-text-secondary"
                />

                {/* Search Results Dropdown - Show only when search is active (focused) */}
                {isSearchActive && ( // Added condition
                  <>
                    {isLoading && (
                      <p className="mt-2 text-sm text-gray-500">
                        جاري البحث...
                      </p>
                    )}
                    {error && (
                      <p className="mt-2 text-sm text-red-500">{error}</p>
                    )}
                    {products && products.length > 0 ? (
                      <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                        {products.map((product, index) => (
                          <li
                            key={product.id || index}
                            className="p-3 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                            onClick={() => {
                              window.location.href = `/product-detail?id=${product.id}`;
                              // Optionally close menu here if desired: setIsMobileMenuOpen(false);
                            }}
                          >
                            {product.name || product.title || "منتج غير معروف"}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      searchQuery &&
                      !isLoading && (
                        <p className="mt-2 text-sm text-gray-500">
                          لا يوجد منتجات مطابقة
                        </p>
                      )
                    )}
                  </>
                )}
              </form>

              {/* Language Switcher 
              <div className="mt-6">
                <LanguageSwitcher />
              </div>*/}

              {/* User Menu Links */}
              <div className="mt-6 border-t border-border pt-6 ">
                {isAuthenticated ? (
                  <>
                    <Link
                      to="/edit-profile"
                      className="block px-4 py-3 text-text-primary hover:bg-muted rounded-lg transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                      role="menuitem"
                    >
                      {t("userMenu.myAccount")}
                    </Link>
                    <Link
                      to="/order-history"
                      className="block px-4 py-3 text-text-primary hover:bg-muted rounded-lg transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                      role="menuitem"
                    >
                      {t("userMenu.myOrders")}
                    </Link>
                    <Link
                      to="/wishlist"
                      className="block px-4 py-3 text-text-primary hover:bg-muted rounded-lg transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                      role="menuitem"
                    >
                      {t("userMenu.wishlist")}
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setIsMobileMenuOpen(false);
                      }}
                      className="w-full text-left px-4 py-3 text-text-primary hover:bg-muted rounded-lg transition-colors"
                      role="menuitem"
                    >
                      {t("userMenu.signOut")}
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/login"
                      className="block px-4 py-3 text-text-primary hover:bg-muted rounded-lg transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                      role="menuitem"
                    >
                      {t("userMenu.signIn")}
                    </Link>
                    <Link
                      to="/register"
                      className="block px-4 py-3 text-text-primary hover:bg-muted rounded-lg transition-colors"
                      onClick={() => setIsMobileMenuOpen(false)}
                      role="menuitem"
                    >
                      {t("userMenu.createAccount")}
                    </Link>
                  </>
                )}
              </div>
            </nav>
          </div>
        )}
      </header>

      {/* CSS Animations */}
      <style>
        {`
      @keyframes slideDown {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .animate-slide-down {
        animation: slideDown 0.3s ease-out;
      }
      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        20%, 60% { transform: translateX(-5px); }
        40%, 80% { transform: translateX(5px); }
      }
      .animate-shake {
        animation: shake 0.5s ease-in-out;
      }
      @keyframes pulseGlow {
        0%, 100% {
          transform: scale(1);
          box-shadow: 0 0 5px rgba(0, 0, 0, 0);
        }
        50% {
          transform: scale(1.1);
          box-shadow: 0 0 8px rgba(128, 128, 128, 0.6);
          border-radius: 50%;
        }
      }
      .animate-pulse-glow {
        animation: pulseGlow 2s infinite;
      }
    `}
      </style>
    </>
  );
};

export default Header;
